import {GET_DATA_FAILED, GET_QUOTAS, ADD_QUOTA, ADD_LOCATION} from "./types";
import Api from '../services/Api'

export const getErrorOccured = (error) => dispatch => {

    dispatch({
        type: GET_DATA_FAILED,
        payload: error
    })
}

export const getQuotas = (locationType) => dispatch => {

    Api.get(`/Quota?locationType=${locationType}`)
    .then(res => res.data)
    .then(quotas => {
        dispatch({
            type: GET_QUOTAS,
            payload: quotas
        });
        var quotaChecked = quotas.filter(q => q.default)[0].quotaSize;
        dispatch({
            type: ADD_QUOTA,
            payload: quotaChecked
        });
    })
}


export const getLocations = (locationType) => dispatch => {
    Api.get(`/Location?locationType=${locationType}`)
        .then(res => res.data)
        .then(locations =>
            {
                if(locations.length > 0) {
                    dispatch({
                        type: ADD_LOCATION,
                        payload: locations[0]
                    })
                }
            }
        );
}


// WEBPACK FOOTER //
// ./src/actions/fetchActions.js